import React, { useState, useContext } from 'react';
import { Modal, Input, Row, Col, Select, DatePicker, Button, Upload, Form, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import form from 'antd/lib/form';
import { RcFile } from "antd/es/upload";
import { UploadOutlined } from '@ant-design/icons';
import { UploadFile } from "antd/lib/upload";
import { AuthContext } from "../../Auth/AuthContext";
import { MdDeleteOutline } from "react-icons/md";
import { getCompanyById, updateCompany } from '../../utils/API';

const { Option } = Select;

interface EditCompanyModalProps {
    visible: boolean;
    onCancel: () => void;
    onSuccess?: () => void;
    onCreate: (values: any) => void;
    onUpdate: (values: any) => Promise<void>;
    initialValues: any;
    refreshLeads: any;
}



const EditCompanyModal: React.FC<EditCompanyModalProps> = ({ visible, onCancel, onCreate, onSuccess, onUpdate, initialValues, refreshLeads }) => {
    const [form] = Form.useForm();
    const { authData } = useContext(AuthContext);
    const [previewImage, setPreviewImage] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);
    console.log("Initial Values:", initialValues);
    const imageurl = process.env.REACT_APP_IMAGE_URL;

    const fetchCompanyDetail = async (companyId: string) => {
        try {
            const company = await getCompanyById(companyId);
            console.log("Fetched Company Detail:", company);
            form.setFieldsValue(company);
            setPreviewImage(`${imageurl}/companies/${company.profilePhoto}`);
            setFileList(company.profilePhoto ? [{ uid: '1', url: `${imageurl}/companies/${company.profilePhoto}` }] : []);
            console.log("Form Values Set:", `${imageurl}/companies/${company.profilePhoto}`);
        } catch (error) {
            console.error("Error fetching company detail:", error);
        }
    };

    React.useEffect(() => {
        if (visible && initialValues) {
            fetchCompanyDetail(initialValues._id);
        }
    }, [visible, initialValues]);

    const getBase64 = (file: File | Blob) =>
        new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const imageProps = {
        name: 'profilePhoto',
        multiple: false,
        beforeUpload(file: RcFile) {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                message.error('You can only upload image files!');
                return Upload.LIST_IGNORE;
            }
            const isLt64M = file.size / 1024 / 1024 < 64;
            if (!isLt64M) {
                message.error('Image must be smaller than 64MB!');
                return Upload.LIST_IGNORE;
            }
            return false;
        }, onChange: async (info: any) => {
            const newFileList = [...info.fileList].slice(-1); // Only keep latest file

            if (newFileList.length > 0) {
                const file = newFileList[0];

                if (file.originFileObj) {
                    const preview = await getBase64(file.originFileObj);
                    file.preview = preview;
                    setPreviewImage(preview);
                } else {
                    setPreviewImage(file.url || file.preview || '');
                }
            } else {
                setPreviewImage('');
            }

            setFileList(newFileList);
        }
        ,
        fileList,
    };
    const handleUpdate = async (values: any) => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            if (fileList.length > 0 && fileList[0].originFileObj) {
                formData.append('profilePhoto', fileList[0].originFileObj);
            }
            formData.append('companyName', values.companyName || '');
            formData.append('email', values.email || '');
            formData.append('phone', values.phone || '');
            formData.append('industry', values.industry || '');
            formData.append('companySize', values.companySize || '');
            formData.append('keyContact', values.keyContact || '');
            formData.append('totalDeals', values.totalDeals || '');

            await updateCompany(initialValues._id, formData);
            message.success("Company updated successfully");
            refreshLeads(); // Refresh the leads after update
            onSuccess?.();
            onCancel();
        } catch (error) {
            console.error("Error updating company:", error);
            message.error("Failed to update company");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={700}
            centered={false}
            destroyOnClose
            className="custom-modal"
            style={{
                bottom: 20,
                top: 20,
                maxHeight: 'calc(100vh - 30px)',
                margin: '0 auto',
                position: 'relative',
            }}

            bodyStyle={{
                overflowY: 'auto',
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Edit Companies
                </div>
            }
        >
            <Form
                onFinish={handleUpdate}
                form={form}
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >
                <div className="elements">
                    <Form.Item labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        className="w-full">
                        <div className="flex justify-center ">
                            <div className="relative w-20 h-20">
                                <Upload.Dragger
                                    {...imageProps}
                                    className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-blue-500 transition-colors bg-gray-50 overflow-hidden"
                                    showUploadList={false}
                                >
                                    {!previewImage ? (
                                        <div className="flex flex-col items-center p-1">
                                            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                                                <UploadOutlined className="text-gray-400 text-base" />
                                            </div>
                                            <span className="text-xs text-gray-400 mt-1">Profile</span>
                                        </div>
                                    ) : (
                                        <img
                                            src={previewImage}
                                            alt="Uploaded"
                                            className="w-full h-full object-cover"
                                        />
                                    )}
                                </Upload.Dragger>

                                {previewImage && (
                                    <Button
                                        type="text"
                                        shape="circle"
                                        size="small"
                                        icon={<MdDeleteOutline size={16} />}
                                        className="absolute top-0 right-0 bg-red-500 text-white hover:bg-red-600 shadow-sm"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImage("");
                                            setFileList([]);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </Form.Item>

                    {/* Company Name */}
                    <Form.Item
                        name="companyName"
                        required={false}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Company Name <span className="text-danger">*</span></span>}
                        rules={[{ required: true, message: "Please enter company name" }]}
                    >
                        <Input
                            size="large"
                            placeholder="Enter Company Name"
                            className="Allinput"
                        />
                    </Form.Item>

                    {/* Email */}
                    <Form.Item
                        name="email"
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Email <span className="text-danger">*</span></span>}
                        required={false}
                        rules={[
                            { required: true, message: "Please enter email" },
                            { type: 'email', message: "Invalid email format" }
                        ]}
                    >
                        <Input
                            size="large"
                            placeholder="Enter Email"
                            className="Allinput"
                        />
                    </Form.Item>

                    {/* Phone */}
                    <Form.Item
                        name="phone"
                        required={false}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Phone Number <span className="text-danger">*</span></span>}
                        rules={[
                            { required: true, message: "Please enter phone number" },
                            { pattern: /^[0-9+\-() ]+$/, message: "Invalid phone number" }
                        ]}
                    >
                        <Input
                            size="large"
                            placeholder="Enter Phone Number"
                            className="Allinput"
                        />
                    </Form.Item>

                    {/* Industry */}
                    <Form.Item
                        name="industry"
                        required={false}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Industry <span className="text-danger">*</span></span>}
                        rules={[{ required: true, message: "Please select industry" }]}
                    >
                        <Select
                            size="large"
                            placeholder="Select Industry"
                            className="CustomSelect"
                        >
                            <Option value="technology">Technology</Option>
                            <Option value="finance">Finance</Option>
                            <Option value="healthcare">Healthcare</Option>
                            <Option value="manufacturing">Manufacturing</Option>
                            <Option value="retail">Retail</Option>
                        </Select>
                    </Form.Item>

                    {/* Company Size */}
                    <Form.Item
                        name="companySize"
                        required={false}
                        rules={[{ required: true, message: "Please select company size" }]}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Company Size <span className="text-danger">*</span></span>}
                    >
                        <Input
                            size="large"
                            placeholder="Select Company Size"
                            className="Allinput"
                        />
                    </Form.Item>

                    {/* Key Contact */}
                    <Form.Item
                        name="keyContact"
                        required={false}
                        rules={[{ required: true, message: "Please enter key contact name" }]}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Key Contact <span className="text-danger">*</span></span>}
                    >
                        <Input
                            size="large"
                            placeholder="Enter Key Contact Name"
                            className="Allinput"
                        />
                    </Form.Item>

                    {/* Total Deals */}
                    <Form.Item
                        name="totalDeals"
                        required={false}
                        rules={[{ required: true, message: "Please enter total deals" }]}
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Total Deals <span className="text-danger">*</span></span>}
                    >
                        <Input
                            size="large"
                            type="number"
                            placeholder="Enter Total Deals"
                            className="Allinput"
                        />
                    </Form.Item>
                </div>

                <Row justify="end">
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        xl={24}
                        xxl={20}
                        className="d-flex justify-content-end me-3"
                    >
                        <div className="button-wrapper">
                            <button
                                className="allcanclebutton"
                                type="button"
                                onClick={onCancel}
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                className="allsubmitebutton"
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default EditCompanyModal;